import { BaseItem } from './common';
import * as InsuranceProvider from './insuranceProvider';
import * as PatientInsuranceInformation from './patient/insuranceInformation';

export enum DocumentType {
  InsuranceCard = 'INSURANCE_CARD',
  PhotoID = 'PHOTO_ID',
  DocumentSigner = 'DOCUMENT_SIGNER',
  OcrVerification = 'OCR_VERIFICATION',
  FreehandBodyDiagram = 'FREEHAND_BODY_DIAGRAM',
  FormSummary = 'FORM_SUMMARY',
}

export enum UploadStatus {
  Uploading = 'UPLOADING',
  Scanning = 'SCANNING',
  Verified = 'VERIFIED',
  Failed = 'FAILED',
  Skipped = 'SKIPPED',
  ExistingDocument = 'EXISTING_DOCUMENT',
}

export enum InsuranceCardSide {
  Front = 'FRONT',
  Back = 'BACK',
}

export interface BaseUpload {
  encounterId: string | null;
  ehrInformationId: string | null;
  gsPath: string;
  documentType: DocumentType;
  existingDocument: boolean;
  existingDocumentUploadDate: Date;
  previsitDocumentTemplateId: string | null;
  status: UploadStatus;
  patientInsuranceInformationId: string | null;
}

export interface PatientUpload extends BaseItem, BaseUpload {}

export interface SignedUploadURLResult {
  id: string;
  url: string;
  patientInsuranceInformationId?: string;
}

export interface PatientUploadWithInsuranceDetails
  extends PatientUpload,
    PatientInsuranceInformation.InsuranceInformation,
    InsuranceProvider.BaseInsuranceProvider {}

export interface FindAllOptions {
  encounterId?: string;
  patientId?: string;
  documentType?: DocumentType;
  status?: UploadStatus;
  includeDeleted?: boolean;
}

export enum PatientUploadKind {
  DocumentSigner = 'DOCUMENT_SIGNER',
  PhotoID = 'PHOTO_ID',
  InsuranceCard = 'INSURANCE_CARD',
}

enum PatientUploadCategory {
  FinancialPolicy = 'FINANCIAL_POLICY',
  MedicationPolicy = 'MEDICATION_POLICY',
  PatientAuthorization = 'PATIENT_AUTHORIZATION',
  PatientConsent = 'PATIENT_CONSENT',
  PrivacyPolicy = 'PRIVACY_POLICY',
}
interface BasePatientUpload {
  category: PatientUploadCategory | null;
  kind: PatientUploadKind;
}

export interface PatientUploadUpdate extends BasePatientUpload {
  gsPaths: string[];
}
